export default (function (siteVars) {
  return {
    selectedColor: siteVars.colors.black,
    selectedBackgroundColor: siteVars.accessibleCyan,
    selectableFocusHoverBackgroundColor: siteVars.accessibleYellow,
    selectableFocusHoverColor: siteVars.colors.black
  };
});